import { Button } from '@newcore/ui/buttons';
import { Sizes } from '@newcore/ui/enums/sizes';
import { ButtonVariants } from '@newcore/ui/enums/variants';

interface ConsentActionsProps {
  allowLabel: string;
  submitting: 'allow' | 'deny' | null;
  disabled: boolean;
  onAllow: () => void;
  onDeny: () => void;
}

export function ConsentActions({
  allowLabel,
  submitting,
  disabled,
  onAllow,
  onDeny,
}: ConsentActionsProps) {
  return (
    <div className='flex flex-col gap-2 w-[352px] max-w-full'>
      <Button
        type='button'
        variant={ButtonVariants.PRIMARY}
        size={Sizes.MD}
        className='w-full'
        isLoading={submitting === 'allow'}
        disabled={disabled}
        onClick={onAllow}
        data-testid='consent-allow-button'
      >
        {allowLabel}
      </Button>
      <Button
        type='button'
        variant={ButtonVariants.SECONDARY}
        size={Sizes.MD}
        className='w-full'
        isLoading={submitting === 'deny'}
        disabled={disabled}
        onClick={onDeny}
        data-testid='consent-deny-button'
      >
        Deny
      </Button>
    </div>
  );
}
